
import reviews from "../../data/review";

import Carousel from "react-bootstrap/Carousel";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default function Review({ title }) {
  return (
    <>
      <div className="review-header text-center mt-5">
        <h2>{title || "Müşteri Yorumları"}</h2>
      </div>
    <div className="review-carousel my-5 bg-success bg-opacity-27 rounded-4 p-4">
    <Carousel interval={null} indicators={false}>
      {reviews.map((review) => (
        <Carousel.Item key={review.id}>
          <div className="review-card text-center p-4">
            <div className="stars mb-3">
              {"★".repeat(review.rating)}
              {"☆".repeat(5 - review.rating)}
            </div>
            <p className="review-text mb-4">{review.comment}</p>
            <div className="review-author">{review.name}</div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
    </div>
    </>
  );
}

// NOTE: interval={5000} indicators={false}
// Interval = > saniyesini gosterir ne kadar surede gecmesi gerektigini eger null olursa kendi kendine donmez kullanici degistiri 
// indicators = > altindaki noktalarin gozukup gokmeme durumu